"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var Radio = function Radio(props) {
  var value = props.value,
      options = props.options,
      defaultValue = props.defaultValue,
      onChange = props.onChange;

  var handleChange = function handleChange(e) {
    var value = e.target.value;
    onChange(value);
  };

  return /*#__PURE__*/_react.default.createElement(_antd.Radio.Group, {
    onChange: handleChange,
    value: value || defaultValue
  }, options && options.map(function (o) {
    return /*#__PURE__*/_react.default.createElement(_antd.Radio, {
      key: o.value,
      value: o.value,
      children: o.name
    });
  }));
};

var _default = Radio;
exports.default = _default;